import createIcon from '../../createIcon';

/**
 * @component @name Height
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMgNi45OUgxNkwxMiAzTDggNi45OUgxMVYxNy4wMUg4TDEyIDIxTDE2IDE3LjAxSDEzVjYuOTlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Height = createIcon('Height', [
  ['path', { d: 'M13 6.99H16L12 3L8 6.99H11V17.01H8L12 21L16 17.01H13V6.99Z', key: '124aeu' }],
]);

export default Height;
